import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import {
  EPOQUE_CONSTRUCTION_OPTIONS,
  TYPE_VITRAGE_OPTIONS,
  STANDING_OPTIONS,
  QUALITE_DISTRIBUTION_OPTIONS,
  APPRECIATION_ECLAIRAGE_OPTIONS,
  DESTINATION_BIEN_OPTIONS,
  ETAT_ENTRETIEN_VETUSTE_OPTIONS,
} from '@/constants/enums';

export default function SectionBati({ data, onChange, categorieExpertise }) {
  const val = (field) => field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const handleChange = (field) => (e) => onChange(field, e.target.value);
  const handleCheck = (field) => (e) => onChange(field, e.target.checked);

  if (categorieExpertise === 'propriete') {
    return (
      <div className="space-y-6">
        {/* Bati Description */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Select
            label="Époque de construction"
            name="bati.epoque_construction"
            value={val('bati.epoque_construction')}
            options={EPOQUE_CONSTRUCTION_OPTIONS}
            onChange={handleChange('bati.epoque_construction')}
          />
          <Input
            label="Date construction (texte libre)"
            name="bati.date_construction_libre"
            value={val('bati.date_construction_libre')}
            onChange={handleChange('bati.date_construction_libre')}
          />
          <Input
            label="Nombre d'étages"
            name="bati.nombre_etages"
            type="number"
            value={val('bati.nombre_etages')}
            onChange={handleChange('bati.nombre_etages')}
          />
          <label className="flex items-center gap-2 text-sm text-slate-700">
            <input
              type="checkbox"
              checked={!!data?.bati?.avec_sous_sol}
              onChange={handleCheck('bati.avec_sous_sol')}
              className="rounded border-slate-300"
            />
            Avec sous-sol
          </label>
          <Input
            label="Style architectural"
            name="bati.style_architectural"
            value={val('bati.style_architectural')}
            onChange={handleChange('bati.style_architectural')}
          />
          <Input
            label="Gros-œuvre"
            name="bati.gros_oeuvre"
            value={val('bati.gros_oeuvre')}
            onChange={handleChange('bati.gros_oeuvre')}
          />
          <Input
            label="Planchers"
            name="bati.planchers"
            value={val('bati.planchers')}
            onChange={handleChange('bati.planchers')}
          />
          <Input
            label="Façades"
            name="bati.facades"
            value={val('bati.facades')}
            onChange={handleChange('bati.facades')}
          />
          <Input
            label="Toiture (nombre de pans)"
            name="bati.toiture_pans"
            type="number"
            value={val('bati.toiture_pans')}
            onChange={handleChange('bati.toiture_pans')}
          />
          <Input
            label="Couverture"
            name="bati.toiture_couverture"
            value={val('bati.toiture_couverture')}
            onChange={handleChange('bati.toiture_couverture')}
          />
          <Input
            label="Huisseries (matériau)"
            name="bati.huisseries_materiau"
            value={val('bati.huisseries_materiau')}
            onChange={handleChange('bati.huisseries_materiau')}
          />
          <Select
            label="Huisseries (vitrage)"
            name="bati.huisseries_vitrage"
            value={val('bati.huisseries_vitrage')}
            options={TYPE_VITRAGE_OPTIONS}
            onChange={handleChange('bati.huisseries_vitrage')}
          />
          <Input
            label="Volets"
            name="bati.volets"
            value={val('bati.volets')}
            onChange={handleChange('bati.volets')}
          />
          <Select
            label="Standing du bâti"
            name="bati.standing_bati"
            value={val('bati.standing_bati')}
            options={STANDING_OPTIONS}
            onChange={handleChange('bati.standing_bati')}
          />
        </div>

        {/* Distribution des niveaux */}
        <h3 className="text-lg font-semibold text-slate-800">Distribution des niveaux</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Input
            label="Sous-sol"
            name="distribution.sous_sol"
            type="textarea"
            value={val('distribution.sous_sol')}
            onChange={handleChange('distribution.sous_sol')}
          />
          <Input
            label="Rez-de-jardin"
            name="distribution.rdj"
            type="textarea"
            value={val('distribution.rdj')}
            onChange={handleChange('distribution.rdj')}
          />
          <Input
            label="Rez-de-chaussée"
            name="distribution.rdc"
            type="textarea"
            value={val('distribution.rdc')}
            onChange={handleChange('distribution.rdc')}
          />
          <Input
            label="R+1"
            name="distribution.r_plus_1"
            type="textarea"
            value={val('distribution.r_plus_1')}
            onChange={handleChange('distribution.r_plus_1')}
          />
          <Input
            label="R+2"
            name="distribution.r_plus_2"
            type="textarea"
            value={val('distribution.r_plus_2')}
            onChange={handleChange('distribution.r_plus_2')}
          />
          <Input
            label="Combles"
            name="distribution.combles"
            type="textarea"
            value={val('distribution.combles')}
            onChange={handleChange('distribution.combles')}
          />
          <Select
            label="Qualité de la distribution"
            name="distribution.qualite_distribution"
            value={val('distribution.qualite_distribution')}
            options={QUALITE_DISTRIBUTION_OPTIONS}
            onChange={handleChange('distribution.qualite_distribution')}
          />
          <Select
            label="Éclairage naturel"
            name="distribution.eclairage_naturel"
            value={val('distribution.eclairage_naturel')}
            options={APPRECIATION_ECLAIRAGE_OPTIONS}
            onChange={handleChange('distribution.eclairage_naturel')}
          />
          <Select
            label="Orientation"
            name="distribution.orientation"
            value={val('distribution.orientation')}
            options={APPRECIATION_ECLAIRAGE_OPTIONS}
            onChange={handleChange('distribution.orientation')}
          />
        </div>
      </div>
    );
  }

  if (categorieExpertise === 'lot') {
    return (
      <div className="space-y-6">
        {/* Ensemble immobilier */}
        <h3 className="text-lg font-semibold text-slate-800">Ensemble immobilier</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Input
            label="Nom de la résidence"
            name="ensemble_immobilier.nom"
            value={val('ensemble_immobilier.nom')}
            onChange={handleChange('ensemble_immobilier.nom')}
            placeholder="ex: Résidence Les Alpages"
          />
          <Input
            label="Nature de l'immeuble"
            name="ensemble_immobilier.nature"
            value={val('ensemble_immobilier.nature')}
            onChange={handleChange('ensemble_immobilier.nature')}
            placeholder="ex: Immeuble collectif de 4 étages"
          />
          <Input
            label="Nombre de lots"
            name="ensemble_immobilier.nb_lots"
            type="number"
            value={val('ensemble_immobilier.nb_lots')}
            onChange={handleChange('ensemble_immobilier.nb_lots')}
          />
          <Input
            label="Nombre de bâtiments"
            name="ensemble_immobilier.nombre_batiments"
            type="number"
            value={val('ensemble_immobilier.nombre_batiments')}
            onChange={handleChange('ensemble_immobilier.nombre_batiments')}
          />
          <Select
            label="Destination de l'immeuble"
            name="ensemble_immobilier.destination_immeuble"
            value={val('ensemble_immobilier.destination_immeuble')}
            options={DESTINATION_BIEN_OPTIONS}
            onChange={handleChange('ensemble_immobilier.destination_immeuble')}
          />
          <Select
            label="Époque de construction"
            name="ensemble_immobilier.epoque_construction"
            value={val('ensemble_immobilier.epoque_construction')}
            options={EPOQUE_CONSTRUCTION_OPTIONS}
            onChange={handleChange('ensemble_immobilier.epoque_construction')}
          />
          <label className="flex items-center gap-2 text-sm text-slate-700">
            <input
              type="checkbox"
              checked={!!data?.ensemble_immobilier?.avec_sous_sol}
              onChange={handleCheck('ensemble_immobilier.avec_sous_sol')}
              className="rounded border-slate-300"
            />
            Avec sous-sol
          </label>
          <Input
            label="Nombre d'étages"
            name="ensemble_immobilier.nombre_etages"
            type="number"
            value={val('ensemble_immobilier.nombre_etages')}
            onChange={handleChange('ensemble_immobilier.nombre_etages')}
          />
          <Select
            label="Standing de l'immeuble"
            name="ensemble_immobilier.standing_immeuble"
            value={val('ensemble_immobilier.standing_immeuble')}
            options={STANDING_OPTIONS}
            onChange={handleChange('ensemble_immobilier.standing_immeuble')}
          />
          <Select
            label="Vétusté"
            name="ensemble_immobilier.vetuste_bati"
            value={val('ensemble_immobilier.vetuste_bati')}
            options={ETAT_ENTRETIEN_VETUSTE_OPTIONS}
            onChange={handleChange('ensemble_immobilier.vetuste_bati')}
          />
          <Input
            label="Parties communes"
            name="ensemble_immobilier.parties_communes"
            type="textarea"
            value={val('ensemble_immobilier.parties_communes')}
            onChange={handleChange('ensemble_immobilier.parties_communes')}
          />
          <Input
            label="Équipements communs"
            name="ensemble_immobilier.equipements_communs"
            type="textarea"
            value={val('ensemble_immobilier.equipements_communs')}
            onChange={handleChange('ensemble_immobilier.equipements_communs')}
          />
        </div>

        {/* Désignation du lot */}
        <h3 className="text-lg font-semibold text-slate-800">Désignation du lot</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Input
            label="Numéro de lot"
            name="designation_lot.numero_lot"
            value={val('designation_lot.numero_lot')}
            onChange={handleChange('designation_lot.numero_lot')}
          />
          <Input
            label="Désignation"
            name="designation_lot.designation"
            type="textarea"
            value={val('designation_lot.designation')}
            onChange={handleChange('designation_lot.designation')}
          />
          <Input
            label="Tantièmes"
            name="designation_lot.tantiemes"
            type="number"
            value={val('designation_lot.tantiemes')}
            onChange={handleChange('designation_lot.tantiemes')}
          />
          <Input
            label="Nombre de pièces"
            name="designation_lot.nombre_pieces"
            type="number"
            value={val('designation_lot.nombre_pieces')}
            onChange={handleChange('designation_lot.nombre_pieces')}
          />
          <label className="flex items-center gap-2 text-sm text-slate-700">
            <input
              type="checkbox"
              checked={!!data?.designation_lot?.avec_annexes}
              onChange={handleCheck('designation_lot.avec_annexes')}
              className="rounded border-slate-300"
            />
            Avec annexes
          </label>
          {data?.designation_lot?.avec_annexes && (
            <Input
              label="Description des annexes"
              name="designation_lot.annexes_description"
              value={val('designation_lot.annexes_description')}
              onChange={handleChange('designation_lot.annexes_description')}
            />
          )}
          <Input
            label="Étage"
            name="designation_lot.etage"
            value={val('designation_lot.etage')}
            onChange={handleChange('designation_lot.etage')}
            placeholder="ex: 3ème étage"
          />
          <Input
            label="Surface Carrez (m²)"
            name="designation_lot.surface_carrez"
            type="number"
            value={val('designation_lot.surface_carrez')}
            onChange={handleChange('designation_lot.surface_carrez')}
          />
          <Input
            label="Quote-part terrain"
            name="designation_lot.quote_part_terrain"
            value={val('designation_lot.quote_part_terrain')}
            onChange={handleChange('designation_lot.quote_part_terrain')}
            placeholder="ex: 125/10000 tantièmes"
          />
        </div>
      </div>
    );
  }

  return null;
}
